import React from "react";
import ATable from "../../common/table";

const MerchantDisputantsTable = props => {
  const columns = [
    {
      header: "S/N",
      width: 50,
      render: row => <div>{props.paginatedCallBack(row.viewIndex)}</div>
    },
    {
      header: "Domain Code",
      accessor: "domainCode"
    },
    {
      header: "Domain Name",
      accessor: "domainName"
    },
    {
      header: "Email Address",
      accessor: "email"
    }
  ];
  return (
    <ATable
      className="-striped -highlight"
      tableData={props.merchantDisputants}
      columns={columns}
      onChange={props.onTableChange || null}
      manual
      {...props}
    />
  );
};

export default MerchantDisputantsTable;



// WEBPACK FOOTER //
// ./src/components/admin/merchantDisputants/merchantDisputantsTable.js